import { createSelector } from 'reselect'

import { AppState } from '../modules'

function getNetwork(state: AppState) {
  return state.network
}

export const isCommunicating = createSelector(getNetwork, network => 0 < network)
